import React from 'react';
function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex gap-0.5" data-id="element-28">
      {[1, 2, 3, 4, 5].map(star => <span key={star} className={`text-sm ${star <= rating ? 'text-yellow-400' : 'text-[#444]'}`} data-id="element-29">
          ★
        </span>)}
    </div>;
}
export function BenefitsSection() {
  const benefits = [{
    icon: '💧',
    title: 'Agua Potable Infinita Sin Salir de tu Piso',
    desc: 'Descubrirás las reservas ocultas de agua que ya existen en tu edificio y cómo purificarla con elementos de cocina. Nunca más la sed será tu enemigo.'
  }, {
    icon: '🍖',
    title: '30 Días de Comida por $50 de Supermercado',
    desc: 'Una lista de compras exacta con alimentos de alta densidad calórica que no requieren refrigeración ni cocina. Tu familia come mientras otros hacen fila en la nada.'
  }, {
    icon: '🏠',
    title: 'Convierte tu Apartamento en una Fortaleza Invisible',
    desc: 'Técnicas militares de "Perfil Bajo" para que tu hogar parezca vacío desde afuera mientras por dentro es la base de operaciones más segura del vecindario.'
  }, {
    icon: '⚡',
    title: 'Energía Off-Grid sin Generadores Ruidosos',
    desc: 'Iluminación táctica, carga solar de dispositivos y gestión de energía para que siempre tengas comunicación e información cuando la red esté muerta.'
  }, {
    icon: '🧠',
    title: 'El Protocolo Mental que Evita el Pánico Familiar',
    desc: 'La técnica OODA de fuerzas especiales adaptada para padres de familia. Tú serás el líder calmado que todos necesitan cuando el mundo entra en caos.'
  }];
  const reviews = [{
    name: 'Carlos M.',
    rating: 5,
    text: 'Armé el kit de emergencia en un fin de semana. Mi señora al principio se reía, pero cuando hubo un apagón de 8 horas en el barrio, fuimos los únicos con agua y luz. Ahora ella también lo recomienda.',
    location: 'Santiago, Chile'
  }, {
    name: 'María José L.',
    rating: 5,
    text: 'Vivo sola con mis dos hijos en un depto de 50m². Pensé que esto no era para mí. Pero el protocolo está pensado exactamente para espacios chicos. Ya tengo reservas para 3 semanas y me siento mucho más tranquila.',
    location: 'Buenos Aires, Argentina'
  }, {
    name: 'Roberto A.',
    rating: 4,
    text: 'El contenido es muy completo y práctico. Lo único que le faltaría es más detalle sobre climas fríos, pero para ciudad funciona perfecto. La sección de agua potable vale el precio completo.',
    location: 'Bogotá, Colombia'
  }, {
    name: 'Valentina R.',
    rating: 5,
    text: 'Mi marido es militar y cuando vio el material dijo "esto es serio". El protocolo mental OODA es exactamente lo que enseñan en entrenamiento. Muy impresionada con la calidad.',
    location: 'Lima, Perú'
  }, {
    name: 'Diego F.',
    rating: 4,
    text: 'Gasté menos de $50 en el supermercado y ya tengo comida para un mes. Las recetas del bono del Chef del Apagón son sorprendentemente buenas. Mi familia ni se quejó.',
    location: 'Medellín, Colombia'
  }];
  return <section className="bg-[#0d0d0d] py-12 px-5" data-id="element-30">
      <div className="max-w-[800px] mx-auto" data-id="element-31">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold text-center mb-8 leading-[1.2]" data-id="element-32">
          Lo que vas a aprender con el{' '}
          <span className="text-brand-orange" data-id="element-33">Protocolo Blackout</span>
        </h2>

        <div className="space-y-3" data-id="element-34">
          {benefits.map((benefit, index) => <div key={index} className="bg-gradient-to-br from-[#141414] to-[#1e1e1e] border border-[#333] hover:border-brand-orange transition-colors duration-300 rounded-xl p-5 md:p-6 flex flex-col sm:flex-row gap-4 items-start" data-id="element-35">
              <div className="bg-gradient-to-br from-brand-orange to-brand-darkOrange rounded-xl w-12 h-12 flex items-center justify-center text-xl shrink-0" data-id="element-36">
                {benefit.icon}
              </div>
              <div data-id="element-37">
                <h3 className="font-oswald text-lg md:text-xl text-white mb-1 font-semibold" data-id="element-38">
                  {benefit.title}
                </h3>
                <p className="text-sm text-[#aaa] leading-[1.5]" data-id="element-39">
                  {benefit.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Reviews Section */}
        <div className="mt-12" data-id="element-40">
          <h3 className="font-oswald text-2xl md:text-3xl font-bold text-center mb-6 leading-[1.2]" data-id="element-41">
            Lo que dicen quienes ya{' '}
            <span className="text-brand-orange" data-id="element-42">se prepararon</span>
          </h3>

          <div className="space-y-3" data-id="element-43">
            {reviews.map((review, index) => <div key={index} className="bg-gradient-to-br from-[#141414] to-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-5 flex gap-4" data-id="element-44">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-orange to-brand-darkOrange flex items-center justify-center text-white font-oswald font-bold text-sm shrink-0" data-id="element-45">
                  {review.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0" data-id="element-46">
                  <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-47">
                    <span className="font-semibold text-white text-sm" data-id="element-48">
                      {review.name}
                    </span>
                    <StarRating rating={review.rating} data-id="element-49" />
                  </div>
                  <p className="text-sm text-[#bbb] leading-[1.5] mb-1.5" data-id="element-50">
                    "{review.text}"
                  </p>
                  <span className="text-xs text-[#666]" data-id="element-51">{review.location}</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}